import { NgModule } from '@angular/core';
import { NetworkStatusComponent } from './network-status.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  exports: [NetworkStatusComponent],
  imports: [SharedModule, NetworkStatusComponent],
})
export class NetworkModule {}
